<form class="vc-admin-form vc-admin-export-form" (ngSubmit)="exportData()">
  <header class="vc-admin-form__intro">
    <h3 class="vc-admin-form__title">{{ "ADMIN.DATA.EXPORT.TITLE" | translate }}</h3>
    <p class="vc-admin-form__subtitle">{{ "ADMIN.IA.DATA.DESCRIPTION" | translate }}</p>
  </header>

  <section class="vc-admin-form__section">
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="export-sites">{{ "ADMIN.DATA.EXPORT.SELECTOR.SITES" | translate }} *</label>
          <p-multiSelect
            inputId="export-sites"
            name="sites"
            [options]="sites"
            [(ngModel)]="selectedSites"
            optionLabel="name"
            display="chip"
            size="small"
            fluid
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-3">
        <div class="field">
          <label for="export-start">{{ "ADMIN.DATA.EXPORT.DATE_START" | translate }} *</label>
          <p-datepicker
            inputId="export-start"
            name="startDate"
            [firstDayOfWeek]="1"
            [(ngModel)]="startDate"
            [showIcon]="true"
            size="small"
            fluid
          ></p-datepicker>
        </div>
      </div>
      <div class="col-12 md:col-3">
        <div class="field">
          <label for="export-end">{{ "ADMIN.DATA.EXPORT.DATE_END" | translate }} *</label>
          <p-datepicker
            inputId="export-end"
            name="endDate"
            [firstDayOfWeek]="1"
            [(ngModel)]="endDate"
            [showIcon]="true"
            [minDate]="startDate"
            size="small"
            fluid
          ></p-datepicker>
        </div>
      </div>
    </div>

    <small class="vc-admin-color-control__hint">
      {{ "ADMIN.DATA.EXPORT.ADVICE" | translate }}
    </small>

    <app-admin-form-actions
      primaryLabelKey="ADMIN.DATA.EXPORT.BUTTON"
      submittingLabelKey="ADMIN.DATA.EXPORT.BUTTON.EXPORTING"
      [submitting]="exporting"
      [disablePrimary]="!selectedSites.length || !startDate || !endDate || exporting"
    ></app-admin-form-actions>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">
      {{ "ADMIN.DATA.EXPORT.QUICK.TITLE" | translate }}
    </h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.DATA.EXPORT.QUICK.SUBTITLE" | translate }}
    </p>
    <div class="vc-admin-export-form__quick">
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.YESTERDAY' | translate" (click)="setMode__yesterday()"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.THIS_WEEK' | translate" (click)="setMode__this_week()"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.LAST_WEEK' | translate" (click)="setMode__last_week()"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.THIS_MONTH' | translate" (click)="setMode__this_month()"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.LAST_MONTH' | translate" (click)="setMode__last_month()"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.THIS_YEAR' | translate" (click)="setMode__this_year()"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm" [label]="'ADMIN.DATA.EXPORT.QUICK.LAST_YEAR' | translate" (click)="setMode__last_year()"></button>
    </div>
  </section>
</form>
